import { combineReducers } from 'redux'
import sliceReducer from '../reducers/sliceReducer'
import userReducer from '../reducers/userReducer'
import commonReducer from '../reducers/commonReducer'
import storeReducer from '../reducers/storeReducer'

const rootReducer = combineReducers({
  user: userReducer,
  common: commonReducer,
  store: storeReducer,
  ui: sliceReducer
})

export default rootReducer
